import React from 'react';
import { IAuditoriaClassificacaoReceitaResultado } from '../interfaces/IAuditoriaClassificacaoReceita';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaClassificacaoReceitaResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria de Classificação de Receita não é um tributo — é uma auditoria de boa prática contábil
// (sem cálculo de multa ou imposto), que detecta débitos lançados diretamente em conta de Receita
// Operacional em vez de na conta redutora de vendas canceladas/devoluções (CPC 47).
const AuditoriaResumoClassificacaoReceita: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.classificacoesIndevidas?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Classificação de Contas de Receita</h3>
      <p className='text-muted'>
        Auditoria de boa prática — débitos lançados diretamente em conta de Receita Operacional, em vez de na conta
        redutora de vendas canceladas/devoluções (CPC 47). Clique para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Valor Classificado Indevidamente</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_CLASSIFICACAO_RECEITA')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Classificação de Contas de Receita</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} ocorrência{totalOcorrencias === 1 ? '' : 's'} identificada{totalOcorrencias === 1 ? '' : 's'} no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFinanceiroTotal)}
                <div className='auditoria-kpi-help'>Sem multa/imposto — auditoria de boa prática contábil.</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoClassificacaoReceita;
